module.exports = __webpack_public_path__ + "media/images/admin/icons/link-2-de4fc6c735a8c59de2ce9e3153caadaf.svg";